import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  getGroupDetails,
  updateGroup,
  deleteGroup,
  addTestsToGroup,
  removeTestFromGroup,
  getAllGroups
} from "../utils/groupApi";
import { getChildGroups } from "../utils/groupApi";
import axios from "axios";

export default function GroupDetails() {
  const { id } = useParams();   // 🔥 Changed from name → id
  const nav = useNavigate();

  const [group, setGroup] = useState(null);
  const [progress, setProgress] = useState(null);
  
  const [edit, setEdit] = useState(false);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [allTests, setAllTests] = useState([]);
  const [selected, setSelected] = useState("");
  const [loading, setLoading] = useState(true);
  const [children, setChildren] = useState([]);
  const [allGroups, setAllGroups] = useState([]);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const editRef = useRef(null);
const [selectedGroupToMove, setSelectedGroupToMove] = useState("");

  useEffect(() => {
    load();
    loadTests();
    loadProgress();
    loadChildren();
    loadAllGroups();  
  }, [id]);  // 🔥 dependency fixed

  const load = async () => {
    try {
      const res = await getGroupDetails(id);
      setGroup(res.data);
      setTitle(res.data.name);
      setDesc(res.data.description);
    } catch (err) {
      console.error("Failed to load group:", err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  const loadTests = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/tests/available`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );
      setAllTests(res.data || []);
    } catch (err) {
      console.error("Failed to load tests:", err.message);
    }
  };


const loadChildren = async () => {
  try {
    const res = await getChildGroups(id);
    setChildren(res.data);
  } catch (err) {
    console.error("Failed to load child groups:", err.message);
  }
};




const loadAllGroups = async () => {
  try {
    const res = await getAllGroups();
    setAllGroups(res.data);
  } catch (err) {
    console.error("Failed to load all groups:", err.message);
  }
};

  const loadProgress = async () => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) return;

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/groups/${id}/progress/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );

      setProgress(res.data);
    } catch (err) {
      console.error("Failed to load progress:", err.message);
    }
  };

  const addTest = async () => {
    if (!selected) return alert("Select test");

    try {
      await addTestsToGroup({
        groupId: group._id,
        testIds: [selected]
      });

      setSelected("");
      load();
      loadProgress();
    } catch (err) {
      console.error("Failed to add test:", err.message);
    }
  };

  const removeTest = async (testId) => {
    if (!window.confirm("Remove test?")) return;

    try {
      await removeTestFromGroup({
        groupId: group._id,
        testId
      });

      load();
      loadProgress();
    } catch (err) {
      console.error("Failed to remove test:", err.message);
    }
  };

  const save = async () => {
    try {
      await updateGroup({
        groupId: group._id,
        name: title,
        description: desc
      });
      setEdit(false);
      load();
    } catch (err) {
      console.error("Update failed:", err.message);
    }
  };

  const removeGroup = async () => {
    

    try {
      await deleteGroup(group._id);
      nav("/groups");
    } catch (err) {
      console.error("Delete failed:", err.message);
    }
  };

const moveGroupHere = async () => {
  if (!selectedGroupToMove) return alert("Select group");

  if (selectedGroupToMove === id)
    return alert("Cannot move group inside itself");

  try {
    await updateGroup({
      groupId: selectedGroupToMove,
      parentId: id
    });

    setSelectedGroupToMove("");
    loadChildren();
  } catch (err) {
    console.error("Move failed:", err.message);
  }
};



const removeChildGroup = async (childId) => {
  if (!window.confirm("Remove this sub playlist from this group?")) return;

  try {
    await updateGroup({
      groupId: childId,
      parentId: null
    });

    loadChildren();
  } catch (err) {
    console.error("Remove failed:", err.message);
  }
};


  if (loading) return <div className="text-center mt-20">Loading…</div>;
  if (!group) return <div className="text-center mt-20">Group not found</div>;

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">

      {/* HERO */}
      <div className="bg-gradient-to-r from-[#8B5A2B] to-[#C48A4A] text-white p-6 rounded-2xl shadow">
        <h1 className="text-2xl font-bold">{group.name}</h1>
        <p className="opacity-90">{group.description}</p>
      </div>


{showDeleteConfirm && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
    <div className="bg-white p-6 rounded-xl shadow-lg w-80">
      <h3 className="text-lg font-semibold mb-4">
        Delete this playlist?
      </h3>

      <div className="flex justify-end gap-3">
        <button
          onClick={() => setShowDeleteConfirm(false)}
          className="px-4 py-2 bg-gray-400 text-white rounded"
        >
          Cancel
        </button>

        <button
          onClick={async () => {
            await removeGroup();
            setShowDeleteConfirm(false);
          }}
          className="px-4 py-2 bg-red-600 text-white rounded"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}
   {edit && (
  <div 
  ref={editRef}
  className="bg-white p-4 rounded-xl shadow">
    <h3 className="font-semibold mb-3">Edit Playlist</h3>

    <input
      className="border p-2 w-full mb-3 rounded"
      value={title}
      onChange={(e) => setTitle(e.target.value)}
      placeholder="Playlist name"
    />

    <textarea
      className="border p-2 w-full mb-3 rounded"
      value={desc}
      onChange={(e) => setDesc(e.target.value)}
      placeholder="Description"
    />

    <div className="flex gap-2">
      <button
        onClick={save}
        className="bg-green-600 text-white px-4 py-2 rounded"
      >
        Save
      </button>

      <button
        onClick={() => setEdit(false)}
        className="bg-gray-400 text-white px-4 py-2 rounded"
      >
        Cancel
      </button>
    </div>
  </div>
)}


      {/* PROGRESS */}
      {progress && (
        <div className="bg-white p-4 rounded-xl shadow">
          <div className="flex justify-between mb-1">
            <span className="font-semibold">Progress</span>
            <span>{progress.percentage || 0}%</span>
          </div>

          <div className="h-3 bg-gray-200 rounded">
            <div
              className="h-3 bg-green-500 rounded"
              style={{ width: `${Math.min(progress.percentage || 0, 100)}%` }}
            />
          </div>

          <p className="text-sm mt-2 text-gray-600">
            {progress.completedTests} completed / {progress.totalTests}
          </p>
        </div>
      )}

      {/* ADD TEST */}
      <div className="bg-white p-4 rounded-xl shadow">
        <h3 className="font-semibold mb-2">Add Test</h3>

        <div className="flex gap-2">
          <select
            className="border p-2 rounded w-full"
            value={selected}
            onChange={e => setSelected(e.target.value)}
          >
            <option value="">Select Test</option>
            {allTests.map(t => (
              <option key={t._id} value={t._id}>
                {t.title}
              </option>
            ))}
          </select>

          <button
            onClick={addTest}
            className="bg-[#8B5A2B] text-white px-4 rounded"
          >
            Add
          </button>
        </div>
      </div>


{/* SUB GROUPS */}
<div className="bg-white p-4 rounded-xl shadow">
  <h3 className="font-semibold mb-3">Sub Playlists</h3>

  {children.length === 0 ? (
    <p className="text-gray-500">No sub playlists yet</p>
  ) : (
    children.map(child => (
      <div
        key={child._id}
        className="border p-3 mb-2 rounded flex justify-between items-center"
      >
        <span
          className="cursor-pointer hover:underline"
          onClick={() => nav(`/groups/${child._id}`)}
        >
          📁 {child.name}
        </span>

        <button
          onClick={() => removeChildGroup(child._id)}
          className="text-sm text-red-500 hover:underline"
        >
          Remove
        </button>
      </div>
    ))
  )}
</div>

  {/* 🔥 Create Sub Group Button */}

  <div className="bg-white p-4 rounded-xl shadow">
  <h3 className="font-semibold mb-3">Create New Sub Playlist</h3>

  <button
    onClick={() => nav(`/groups/create/${group._id}`)}
    className="w-full bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded transition"
  >
    ➕ Create Sub Playlist
  </button>
</div>

{/* MOVE EXISTING GROUP */}
<div className="bg-white p-4 rounded-xl shadow">
  <h3 className="font-semibold mb-3">Add Existing Group Here</h3>

  <select
    className="border p-2 w-full mb-3 rounded"
    value={selectedGroupToMove}
    onChange={(e) => setSelectedGroupToMove(e.target.value)}
  >
    <option value="">Select Group</option>

    {allGroups
      .filter(g => g._id !== id && g.parentId !== id)
      .map(g => (
        <option key={g._id} value={g._id}>
          {g.name}
        </option>
      ))}
  </select>

  <button
    onClick={moveGroupHere}
    className="w-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded transition"
  >
    ➕ Add This Group
  </button>
</div>


      {/* TEST CARDS */}
      <div className="grid md:grid-cols-2 gap-4">
        {group.testIds?.map(t => (
          <div
            key={t._id}
            className="bg-white p-4 rounded-xl shadow hover:scale-[1.01] transition"
          >
            <h4
              onClick={() => nav(`/test/${t.type || "practice"}/${t._id}`)}
              className="font-semibold cursor-pointer hover:underline"
            >
              {t.title}
            </h4>

            <div className="flex justify-between mt-3">
              <button
                onClick={() => nav(`/test/${t.type || "practice"}/${t._id}`)}
                className="text-sm text-green-600"
              >
                Start →
              </button>

              <button
                onClick={() => removeTest(t._id)}
                className="text-sm text-red-500"
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* ADMIN */}
      <div className="flex gap-2">
        <button
  onClick={() => {
    setEdit(true);

    setTimeout(() => {
      editRef.current?.scrollIntoView({ behavior: "smooth",block: "start" });
    }, 100);
  }}
  className="px-4 py-2 bg-blue-500 text-white rounded"
>
  Edit Playlist
</button>

        <button
          onClick={() => setShowDeleteConfirm(true)}
          className="px-4 py-2 bg-red-500 text-white rounded"
        >
          Delete Playlist
        </button>
      </div>

    </div>
  );
}